module.exports = __webpack_public_path__ + "img/ai_mode.dec64fdb.png";